import functions from "@/functions/functions";

export default (Vue) => {
    Vue.mixin({
        beforeCreate() {
            if(!this.$ns) {
                this.$ns = {}
                functions(this)
            }
        },
    })
};
